import { Box, Grid, Typography, Button, CircularProgress } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import { useState, useEffect } from 'react'
import { Role, User } from '@types'
import EditIcon from '@material-ui/icons/Edit'
import BlockIcon from '@material-ui/icons/Block'
import { useSelector } from 'react-redux'
import RowProfile from '../components/RowProfile'
import { executivesSelector, selectViewingProfile } from '../state/trackingSlice2'
import { userProfile as loggedProfile } from '@views/profile/state/profileSlice'

interface Props {
  handleChangeUser: (dataProfile: User) => void
  onClick: () => void
}

const ProfileModal: React.FC<Props> = ({ onClick, handleChangeUser }) => {
  const [showInput, setShowInput] = useState(false)
  const userProfile = useSelector(selectViewingProfile)
  const { role } = useSelector(loggedProfile)
  const [dataProfile, setDataProfile] = useState(userProfile)
  const executivesList = useSelector(executivesSelector)

  const onlyNumber = /^[0-9]+$/

  useEffect(() => {
    setDataProfile(userProfile)
  }, [userProfile])

  const handleCommentAdmin = (e: any) => {
    e.preventDefault()
    if (dataProfile?.email.includes('.') && dataProfile?.email.includes('@') && !dataProfile?.email.includes(' ')) {
      handleChangeUser({
        ...dataProfile,
        email: dataProfile?.email.toLowerCase()
      })
    }

    setShowInput(false)
  }

  const handleUserProfile = (name: string, value: string) => {
    if (name === 'document' || name === 'phone' || name === 'income') {
      if (onlyNumber.test(value) || value === '') {
        setDataProfile({ ...dataProfile, [name]: value })
      }
    } else if (name === 'executive') {
      const executive = executivesList.find(e => e.name === value)
      setDataProfile({
        ...dataProfile,
        [name]: {
          id: executive?._id,
          name: executive?.name
        }
      })
    } else {
      setDataProfile({ ...dataProfile, [name]: value })
    }
  }

  return (
    <div className="center_view_see_modal">
      <Box boxShadow="3px 2px 8px 3px light-gray" borderRadius="10px" width="100%" height="100%" position="relative">
        {userProfile.document !== '' ? (
          <>
            <Box
              padding="10px 0"
              style={{
                borderBottom: '2px solid lightgray',
                width: '90%',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '10px'
              }}
              color="##292929"
            >
              <div>
                <Typography
                  style={{
                    color: '#292929',
                    fontSize: '16px',
                    fontWeight: 'bolder'
                  }}
                >
                  {userProfile.name}
                </Typography>
                <Typography style={{ color: 'rgb(252, 177, 90)', fontSize: '14px' }}>
                  {userProfile.role?.toUpperCase()}
                </Typography>
              </div>
              <div
                style={{
                  justifyContent: 'space-between',
                  display: 'flex',
                  alignItems: 'center',
                  width: '60px'
                }}
              >
                {showInput ? (
                  <BlockIcon
                    onClick={() => setShowInput(false)}
                    style={{ color: 'rgb(252, 177, 90)', cursor: 'pointer' }}
                  />
                ) : role === Role.admin || role === Role.operaciones ? (
                  <EditIcon
                    onClick={() => setShowInput(true)}
                    style={{
                      color: 'rgb(252, 177, 90)',
                      cursor: 'pointer'
                    }}
                  />
                ) : (
                  <></>
                )}
                <CancelIcon onClick={() => onClick()} style={{ color: 'rgb(252, 177, 90)', cursor: 'pointer' }} />
              </div>
            </Box>

            <Box padding="10px 0" style={{ width: '87%', margin: '0 auto' }}>
              <Grid container direction="column" spacing={2}>
                <RowProfile
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Nombre"
                  data={dataProfile?.name || ''}
                  name="name"
                />
                <RowProfile
                  name="phone"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Telefono"
                  data={dataProfile?.phone || ''}
                />
                <RowProfile
                  name="document"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Cedula"
                  data={dataProfile?.document || ''}
                />
                <RowProfile
                  name="email"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Email"
                  data={dataProfile?.email || ''}
                />
                <RowProfile
                  name="city"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Ciudad"
                  data={dataProfile?.city || ''}
                />
                <RowProfile
                  name="bank"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Banco"
                  data={dataProfile?.bank || ''}
                />
                <RowProfile
                  name="comments"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Comentarios"
                  data={dataProfile?.comments || ''}
                />
                <RowProfile
                  name="income"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Ingresos"
                  data={dataProfile?.income || ''}
                />
                <RowProfile
                  name="executive"
                  handleUserProfile={handleUserProfile}
                  showInput={showInput}
                  title="Ejecutivo"
                  data={dataProfile?.executive?.name || ''}
                  executiveList={executivesList}
                />

                {showInput && (
                  <Button
                    style={{
                      marginTop: '10px',
                      marginBottom: '15px'
                    }}
                    variant="contained"
                    color="primary"
                    onClick={e => handleCommentAdmin(e)}
                  >
                    Guardar cambios
                  </Button>
                )}
              </Grid>
            </Box>
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
              width: '100%'
            }}
          >
            <CircularProgress style={{ color: '#ff6900' }} />
          </div>
        )}
      </Box>
    </div>
  )
}

export default ProfileModal
